import { PropsWithChildren } from 'react';
import { Badge } from '@resultadosdigitais/tangram-components';
import styled, { keyframes } from 'styled-components';

const IndicatorAnimation = keyframes`
  to {opacity: 1;}
`;

const IndicatorBadge = styled(Badge)`
  ${Badge.Style} {
    top: auto;
    transform: none;
    bottom: 0;
    margin-left: 0;
    opacity: 0;
    animation-name: ${IndicatorAnimation};
    animation-delay: 1s;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
`;

export const Indicator = ({ children }: PropsWithChildren<{}>) => {
  return <IndicatorBadge kind={Badge.kinds.success}>{children}</IndicatorBadge>;
};
